export default __webpack_public_path__ + "static/media/ecology.442aa97b.png";